export default {
    deviceModel_typeName: "Название типа",
    deviceModel_typeNameRule: "Название типа не может быть пустым",

    deviceCheck_tips: "Вы уверены, что хотите импортировать клиентов?",
    deviceCheck_normalDevcieSucc: "Импорт исправных устройств выполнен успешно!",
    deviceCheck_normalDevcieLose: "Не удалось импортировать исправные устройства!",
    deviceCheck_selectDevice: "Сначала выберите организацию для исправных устройств!",
    deviceCheck_abnormalDevcieSucc: "Импорт неисправных устройств выполнен успешно!",
    deviceCheck_abnormalDeviceLose: "Не удалось импортировать неисправные устройства!",
    deviceCheck_selectAbnormalDevcie: "Сначала выберите организацию для исправных устройств!",

    AlarmPlatform_deviceNo3D: "Устройство не привязано к 3D-карте",
    AlarmPlatform_devcieNoModel: "Устройство не привязано к 3D-модели",
    AlarmPlatform_alarmBanister_noCHeck: "Панель приёма тревог свободна, просмотр недоступен",
    AlarmPlatform_noSpacing: "Ввод не может содержать пробелы",
    AlarmPlatform_noDeviceType: "Нет типов устройств",
    AlarmPLatform_noAlarmLog: "Нет журнала тревог",

    DutyLogManage_messageLogsNoSpacing: "Содержимое журнала не может состоять только из пробелов!",
    DutyLogManage_messageLog: "Содержимое журнала не может состоять только из пробелов!",
    DutyLogManage_messageAddSucc: "Добавление выполнено успешно!",
    DutyLogManage_messageAddLose: "Не удалось добавить!",

    entity_enttiyName: "Название организации",
    entity_enttiyNameRule: "Введите название организации",
    entity_platformLogName: "Название платформы",
    entity_platformLogNameRule: "Введите название платформы",
    entity_platformLogNameRule_noSpace: "Название платформы не может быть пустым",
    entity_clcikMapPla: "Нажмите для просмотра устройств, на карте отобразятся устройства организации",
    entity_clearImp: "Изображения в списке успешно удалены!",

    userManage_loginNamePla: "11-значный номер телефона или буквы и цифры",
    userManage_passwordPla: "Введите пароль",
    userManage_UserNnamePla: "Введите имя",
    userManage_PhonePla: "Введите контактный телефон",
    userManage_genderPla: "Выберите пол",
    userManage_rolePla: "Выберите роль",
    userManage_entityPla: "Выберите организацию",
    userManage_registerPla: "Выберите, разрешён ли вход",
    userManage_imgUpData: "Выберите файл для загрузки",
    userManage_imgTitle: "Загруженные изображения проверки",
    userManage_superUser: "Супер-администратор",
    userManage_produceUser: "Администратор производства",
    userManage_appletUser: "Администратор мини-программы",
    userManage_unitUser: "Администратор организации",
    userManage_addUserSucc: "Пользователь успешно добавлен",
    userManage_userExist: "Данный аккаунт уже существует",
    userManage_addUserLose: "Не удалось добавить пользователя",

    pointManage_pointAddrRule: "Адрес точки не может быть пустым",
    pointManage_pointNameRule: "Название точки не может быть пустым",

    Digital_Online_rate: "Процент онлайн",
    Digital_mapCheckDevcie: "Просмотр устройств",
    Digital_mapCheckFloor: "Просмотр этажей",

    temporary_phoneChangPla: "Вы уверены, что хотите изменить номер для приёма звонков?",
    temporary_smsChangPla: "Вы уверены, что хотите изменить номер для приёма SMS?",

    devcieBind_seleceMap: "Выберите положение на карте!",
    devcieBind_seleceMapLose: "Выберите объект или создайте новый!",

    alarmRecord_allAlarmState: "Все состояния тревог",

    linkRule_openState: "Вы уверены, что хотите изменить состояние включения?",

    noData_threeDModel: "Нет 3D-модели",
    noDevcieData: "Нет данных об устройствах",

    video_start: "Старт",
    video_suspend: "Пауза",
    video_multiple: "Скорость воспроизведения",
    video_modeSelect: "Выбор режима",
    video_control: "Управление видео",
    video_playVideo: "Воспроизведение",
    video_refresh: "Обновить",
    video_dataName: "Имя файла",
    video_messaeErr: "Не удалось загрузить запись! Нажмите «Обновить»!",
    video_palyBalck: "Воспроизведение записи",
    videe_levelShift: "Скорость горизонтального перемещения",
    videe_verticalShift: "Скорость вертикального перемещения",
    vide_videoManipulation: "Управление мониторингом",
    vide_regionalSetting: "Настройка области",
    vide_clearCanvas: "Очистить холст",
    vide_saveCoordinate: "Сохранить координаты",
    OpenPerimeter: "Включить периметр",
    ClosePerimeter: "Выключить периметр",
    setPerimeterErr: "Не удалось настроить периметр",
    vide_morePoints: "Можно задать не более 6 точек!",
    vide_leastPoints: "Требуется не менее 3 точек!",
    vide_minPoint: "Минимальное количество точек",
    vide_maxPoint: "Максимальное количество точек",
    vide_savePointsOk: "Настройки действительны, готово к сохранению",
    vide_savePointsError: "Область недействительна, настройте заново",
    video_loding: "Загрузка списка видео...",

    videoSys_enven: "Событие",
    videoSys_img: "Изображение",
    videoSys_online: "В сети",
    videoSys_downline: "Не в сети",
    videoSys_fault: "Неисправность",
    videoSys_alarm: "Тревога",
    videoSys_heartbeat: "Сердцебиение",
    videoSys_flameAlarm: "Тревога обнаружения пламени",
    videoSys_smokeAlarm: "Тревога обнаружения дыма",
    videoSys_flameSomkeAlarm: "Тревога пожара (пламя+дым)",
    videoSys_electrocarAlarm: "Тревога распознавания электромобиля",
    videoSys_unknownEvent: "Неизвестное событие",
    videoSys_heartbearEvent: "Событие сердцебиения",
    videoSys_faceRecognition: "Распознавание лица",

    videoSys_loading: "Загрузка...",
    videoSys_devcieDownLin: "Устройство не в сети",
    videoSys_allVideoList: "Все данные загружены",
    videoSys_videoControls: "Управление камерой",
    videoSys_title: "Система видеонаблюдения облачной платформы",
    videoSys_fullScreen: "Полный экран",
    videoSys_clearAll: "Закрыть все",
    videoSys_closeSel: "Закрыть выбранные",
    videoSys_passage: "Канал",
    videoSys_loadingTwo: "Загрузка...",
    videoSys_quitFullScren: "Выйти из полноэкранного режима",
    videoSys_playLose: "Воспроизведение не удалось, удалите и выберите устройство снова",
    imgae_floor: "Сначала измените точку",

    devcieDetails_smokeArgument: "Параметры хоста дымового извещателя 433",
    devcieDetails_smokeHardware: "Версия аппаратуры",
    devcieDetails_smokeSoftWare: "Версия ПО",
    devcieDetails_smokeBu: "Снятие/постановка под охрану",
    devcieDetails_smokeSeparate: "Норма/разъединение",
    devcieDetails_smokeAudio: "Звук/без звука",
    devcieDetails_smokeErasureAudio: "Не отключён звук/отключён звук",
    devcieDetails_smokeOpen: "Клапан закрыт/открыт",
    devcieDetails_smokeMessErr: "Не удалось получить параметры хоста дымового извещателя",
    devcieDetails_smokeBind: "Привязано",
    devcieDetails_smokeNoBind: "Не привязано",
    devcieDetails_smokeIsBind: "Привязать?",
    devcieDetails_smokeChangerAddr: "Изменить адрес и точку",
    devcieDetails_smokeAddr: "Адрес",
    devcieDetails_smokeAddrRule: "Координаты точки не могут быть пустыми",
    devcieDetails_smokeAddrPla: "Введите адрес",
    devcieDetails_smokePlachangePoint: "Сначала измените точку на карте",
    devcieDetails_smokePointTip: "Перетащите маркер на карте для изменения точки",
    devcieDetails_addSmokePointTip: "Нажмите на карту, чтобы задать точку",
    devcieDetails_smokeBian: "Редактировать",
    devcieDetails_smokePointChange: "Измените точку!",

    mqtt_deviceAlarm: "Тревога устройства",
    mqtt_deviceAlarmDetail: "Подробности тревоги",
    mqtt_checkVideo: "Просмотр видео",
    mqtt_model: "3D-модель",

    siteNoEmpty: "Объект не может быть пустым!",
    time: "Время",

    site_businessHours: "Часы работы",
    site_businessState: "Статус работы",
    site_businessStatePla: "Выберите статус работы",
    site_businessStateOpt1: "Работает",
    site_businessStateOpt2: "Приостановлено",
    site_businessStateOpt3: "Действует",
    header_closeBlackAlarmDevice: "Чёрный список тревог устройств",
    header_alarmBell: "Звук тревоги",
    header_alarmRadio1: "Озвучивание адреса тревоги",
    header_alarmRadio2: "Озвучивание звука тревоги",

    exportAll_pla: "Вы уверены, что хотите экспортировать все данные при текущих условиях?",
    exportAll_btn: "Экспорт всего",

    user_name: "Имя владельца",
    user_namePla: "Введите имя владельца",
    user_phone: "Номер владельца",
    installationPersonnel: "Установщик",
    installationPersonnel_input: "Введите имя установщика",

    user_phonePla: "Введите телефон владельца",
    install_personnel: "Установщик",

    install_time: "Время установки",

    site_nameLength: "Длина не должна превышать 50 символов",

    upData_imgPla: "Загрузите изображение в формате .png или .jpg!",

    alarm_log_title: "Пока нет записей о тревогах",
}
